import type FontPickerStore from './schema/FontPickerStore';
import { FONT_NAME_MENU_ITEMS, FONT_SIZE_MENU_ITEMS } from 'owa-format-options';
import { createStore } from 'satcheljs';

const fontPickerStoreData: FontPickerStore = {
    fontName: {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (10,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        displayValue: null,
        mru: [],
        items: [...FONT_NAME_MENU_ITEMS],
    },
    fontSize: {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (18,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        displayValue: null,
        mru: [],
        items: [...FONT_SIZE_MENU_ITEMS],
    },
    isLocalFontListLoaded: false,
};

export const store = createStore<FontPickerStore>('fontPicker', fontPickerStoreData)();
export const getStore = () => store;
